export class EmailConfirmationRequest {
    constructor(
        public userId: string,
        public code: string,
        public confirm: string) {
    }

}